<template>

<com-item name="games.timeline" :size="size" :loading="loading" :is-empty="!active" title="Discovery Timeline">

	<template v-slot:about>

		<p>New games entering {{ your }} universe over time.</p>

	</template>

	<template v-slot:stats>

		<app-visualisation-bars :data="chart" v-if="active" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

	data: function() {

		return {
			chart: {
				datasets: [
					{ type: 'bar', data: [], yAxis: 'right', backgroundColor: '#4881bb', tooltip: '{{value}} added <small>{{x.label}}</small>' },
					{ type: 'bar', data: [], yAxis: 'right', backgroundColor: '#7a5fbf', tooltip: '{{value}} prev. owned <small>{{x.label}}</small>' },
					{ type: 'bar', data: [], yAxis: 'right', backgroundColor: '#2FC482', tooltip: '{{value}} played <small>{{x.label}}</small>' },
					{ type: 'bar', data: [], yAxis: 'right', backgroundColor: '#f5a623', tooltip: '{{value}} rated <small>{{x.label}}</small>' },
					{ type: 'bar', data: [], yAxis: 'right', backgroundColor: '#e85d75', tooltip: '{{value}} wishlisted <small>{{x.label}}</small>' },
					{ type: 'point', data: [], yAxis: 'left', backgroundColor: '#217EA8', tooltip: '{{value}} {{change}} <small>Universe size</small>', lineColor: '#217EA8', shadeColor: '#d1f1ff' }
				],
				axis: {
					x: { labels: [] },
					y: {
						left: {
							type: 'scale',
							min: 100,
							points: 5
						},
						right: {
							type: 'scale',
							min: 10,
							points: 5
						}
					}
				}
			}
		}

	},

	computed: {

		loading: function() {

			return this.fetching === 'all'

		},

		storeData: function() {

			return this.$store.getters['page/insights/games/timeline']

		},

		active: function() {

			return this.storeData && !this.loading && Object.keys(this.storeData).length && this.storeData.byType && this.storeData.byType.length

		}

	},

	watch: {

		storeData: function() {

			this.visualise()

		}

	},

	created: function() {

		this.visualise()

	},

	methods: {

		visualise: function() {

			if (!this.storeData || !this.storeData.byType) return

			this.chart.axis.x.labels = this.storeData.byType.map(function(item) {
				return { label: item.year.toString() }
			})

			this.chart.datasets[0].data = this.storeData.byType.map(function(item) {
				return item.owned
			})

			this.chart.datasets[1].data = this.storeData.byType.map(function(item) {
				return item.prevowned || 0
			})

			this.chart.datasets[2].data = this.storeData.byType.map(function(item) {
				return item.played
			})

			this.chart.datasets[3].data = this.storeData.byType.map(function(item) {
				return item.rated
			})

			this.chart.datasets[4].data = this.storeData.byType.map(function(item) {
				return item.wishlisted
			})

			this.chart.datasets[5].data = this.storeData.byType.map(function(item) {
				return item.total
			})

		}

	}

}

</script>

<style scoped>

</style>
